import React from 'react';
import { FaShieldAlt, FaLeaf, FaStethoscope, FaEye, FaClock, FaStickyNote, FaChevronRight } from 'react-icons/fa';

/**
 * Shared "record card" shell (patient name/avatar + meta + highlighted item rows + note/timestamp footer)
 * used across Prescriptions, Lab Tests, Billing, EMR and Pharmacy list views.
 */
const RecordCard = ({
  avatarLetter,
  avatarImage,
  title,
  meta = [],
  subLabel,
  items = [],
  note,
  noteLabel = 'Note',
  timestamp,
  onView,
  actions,
  children,
}) => (
  <div className="record-card">
    <div className="record-card-accent" />
    <div className="record-card-side">
      <div className="record-card-avatar">
        {avatarImage ? <img className="record-card-avatar-img" src={avatarImage} alt="" /> : avatarLetter}
        <span className="record-card-avatar-badge"><FaShieldAlt /></span>
      </div>
      <FaLeaf className="record-card-leaf" />
    </div>
    <div className="record-card-main">
      <FaStethoscope className="record-card-watermark" />
      {actions && <div className="record-card-actions">{actions}</div>}
      {onView && (
        <button className="record-card-view-btn" onClick={onView} title="View details" type="button">
          <FaEye />
        </button>
      )}
      <div className="record-card-title">{title}</div>
      {meta.length > 0 && (
        <div className="record-card-meta">
          {meta.map((m, i) => (
            <React.Fragment key={i}>
              {i > 0 && <span className="record-card-meta-sep">|</span>}
              <span className="record-card-meta-item">{m.icon}{m.text}</span>
            </React.Fragment>
          ))}
        </div>
      )}
      {subLabel && <div className="record-card-sublabel">{subLabel}</div>}

      {items.map((it, i) => (
        <div className="record-card-item-row" key={i}>
          <span className="record-card-item-icon">{it.icon}</span>
          <span className="record-card-item-name">{it.name}</span>
          {it.badges && it.badges.length > 0 && (
            <span className="record-card-item-badges">
              {it.badges.map((b, bi) => <span className="record-card-badge" key={bi}>{b}</span>)}
            </span>
          )}
          {onView && (
            <button className="record-card-chevron" onClick={onView} title="View details" type="button">
              <FaChevronRight />
            </button>
          )}
        </div>
      ))}

      {(note || timestamp) && (
        <div className="record-card-footer">
          {note && <span className="record-card-note"><FaStickyNote />{noteLabel}: {note}</span>}
          {timestamp && <span className="record-card-timestamp"><FaClock />{timestamp}</span>}
        </div>
      )}
      {children}
    </div>
  </div>
);

export default RecordCard;
